module.exports = __webpack_public_path__ + "static/media/helpcard_expendables.f725b97d.svg";